import { defineAsyncComponent } from 'vue';
import VueToast from 'vue-toast-notification';
import 'vue-toast-notification/dist/theme-sugar.css';
import { mountApp, app } from '@/js/app-entries/app-entry-points/global';

const Converter = defineAsyncComponent(() => import('@/js/cryptocurrencies/converter/Converter.vue'));
const ChartWrapper = defineAsyncComponent(() => import('@/js/cryptocurrencies/ChartWrapper.vue'));
const ShareIcons = defineAsyncComponent(() => import('@/js/components/Tippy/ShareTippy/ShareIcons.vue'));
const ShareTippy = defineAsyncComponent(() => import('@/js/components/Tippy/ShareTippy/ShareTippy.vue'));
const LearnListButton = defineAsyncComponent(() => import('@/js/global/buttons/LearnListButton.vue'));
const TopExchangesTippy = defineAsyncComponent(() => import('@/js/components/Tippy/TopExchangesTippy/TopExchangesTippy.vue'));
const SocialsChart = defineAsyncComponent(() => import('@/js/other/SocialsChart.vue'));

app.use(VueToast);

app.component('Converter', Converter);
app.component('ChartWrapper', ChartWrapper);
app.component('ShareIcons', ShareIcons);
app.component('LearnListButton', LearnListButton);
app.component('ShareTippy', ShareTippy);
app.component('TopExchangesTippy', TopExchangesTippy);
app.component('SocialsChart', SocialsChart);

mountApp();
